import 'ldrs/react/Ring.css'

import { Ring } from 'ldrs/react'
interface RingProps {
  size?: number | string
  color?: string
  speed?: number | string
  stroke?: number | string
  bgOpacity?: number | string
}

export default function UiRing(props: RingProps) {
  return <Ring {...props} />
}
